/**
 * Product Grid Mobile Layout Toggle
 * Handles toggling between 1 and 2 items per row on mobile.
 * Remembers the preference in a cookie.
 */
class ProductGridMobileToggle {
    constructor() {
        this.gridId = 'product-grid';
        this.cookieName = 'product_grid_mobile_layout';
        this.oneItemClass = 'one-item-per-row-mobile';
        this.activeClass = 'active';
        this.init();
    }

    setCookie(value) {
        const expires = new Date(Date.now() + 7 * 864e5).toUTCString();
        document.cookie = `${this.cookieName}=${value}; expires=${expires}; path=/; SameSite=Lax`;
    }

    getCookie() {
        return document.cookie.split('; ').reduce((r, v) => {
            const parts = v.split('=');
            return parts[0] === this.cookieName ? decodeURIComponent(parts[1]) : r;
        }, '');
    }

    updateLayout(layout) {
        const grid = document.getElementById(this.gridId);
        const buttons = document.querySelectorAll('[data-items-per-row-mobile]');

        if (grid) {
            if (layout === '1') {
                grid.classList.add(this.oneItemClass);
            } else {
                grid.classList.remove(this.oneItemClass);
            }

            grid.querySelectorAll('.card--product img[sizes]').forEach(image => {
                image.dataset.gridSizes ||= image.sizes;
                image.sizes = layout === '1'
                    ? `(max-width: 749px) calc(100vw - 32px), ${image.dataset.gridSizes}`
                    : image.dataset.gridSizes;
            });
        }

        buttons.forEach(btn => {
            if (btn.getAttribute('data-items-per-row-mobile') === layout) {
                btn.classList.add(this.activeClass);
            } else {
                btn.classList.remove(this.activeClass);
            }
        });

        // Fire a resize event to trigger any lazyloading or layout recalculations
        window.dispatchEvent(new Event('resize'));
    }

    init() {
        const layout = this.getCookie() || '2';

        // Initial apply
        // We do it as soon as possible, but also on DOMContentLoaded
        this.updateLayout(layout);

        document.addEventListener('click', (e) => {
            const button = e.target.closest('[data-items-per-row-mobile]');
            if (!button) return;

            const newLayout = button.getAttribute('data-items-per-row-mobile');
            this.setCookie(newLayout);
            this.updateLayout(newLayout);
        });

        // Handle grid replacement from facets (AJAX)
        // Dawn dispatches theme:loading:end or we can observe changes
        document.addEventListener('theme:loading:end', () => {
            const currentLayout = this.getCookie() || '2';
            this.updateLayout(currentLayout);
        });

        // Fallback for different theme events
        document.addEventListener('facet-updated', () => {
            const currentLayout = this.getCookie() || '2';
            this.updateLayout(currentLayout);
        });
    }
}

// Initialize
if (!window.productGridMobileToggle) {
    window.productGridMobileToggle = new ProductGridMobileToggle();
}
